import styled from '@emotion/styled';
import {Button, Grid} from '@mui/material';

export const NavigationButtonsTiff = styled('div')`
  width: 100%;
  min-width: 45vw;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-items: flex-end;
`;
export const IconButtonWrapper = styled(Button)`
  border-radius: 50%;
  width: 36px;
  height: 36px;
  min-width: unset;
  padding: 0;
  margin-right: 0px;

  .MuiSvgIcon-root {
    width: 24px;
    height: 24px;
    margin: auto;
    display: block;
  }
`;
export const TextContainer = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
  width: 50vw;
`;
export const TextLayerStyles = styled('div')`
  .react-pdf__Page__textContent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: auto; /* Ensure the text layer is interactable */
  }

  .react-pdf__Page__textContent div {
    display: inline-block;
    transform-origin: 0 0;
    white-space: pre;
    pointer-events: all;
    cursor: text;
  }
`;
